import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs, ptlUtils } from "../../../comn";

/*
 * Vehicle Maker Management
 * !== 차량 제조사 관리 기능 서비스 ==!
 */

export const BASE = {
    path: `${ptlEnvs.base}/ctra/vhcl`,
    api: `${process.env.REACT_APP_API_PTL_COMN}/api/v1/osci/ptl/ctra/vhcl`,
    nodes: [{ label: "Portal" }, { label: "Criteria Information Management" }, { label: "Vehicle Maker Management" }],
};

export const URLS = {
    osci0105003q: `${BASE.path}/osci0105003q`,
    osci0105004s: `${BASE.path}/osci0105004s`,
    osci0105005s: `${BASE.path}/osci0105005s`,
    osci0105006q: `${BASE.path}/osci0105006q`,
};

export const APIS = {
    // Get the List of Vehicle Maker Management !== 차량 제조사 관리 목록 조회 ==!
    getVhclMkerList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },

    getVhclMkerInfo: (vhclMkerCd: any) => {
        return api.get(`${BASE.api}/${vhclMkerCd}`);
    },

    getVhclMdlList: (vhclMkerCd: any) => {
        return api.get(`${BASE.api}/mdl/${vhclMkerCd}`);
    },

    getVhclMdlNoList: (vhclMkerCd: any, vhclMdlCd: any) => {
        return api.get(`${BASE.api}/mdlNo/${vhclMkerCd}/${vhclMdlCd}`);
    },

    saveVhclMkerInfo: (data: any) => {
        return api.post(`${BASE.api}`, {
            ...data,
        });
    },

    deleteVhclMkerInfo: (vhclMkerCd: any) => {
        return api.delete(`${BASE.api}/${vhclMkerCd}`);
    },

    getVhclMdlInfo: (vhclMkerCd: any, vhclMdlCd: any) => {
        return api.get(`${BASE.api}/mdl/${vhclMkerCd}/${vhclMdlCd}`);
    },

    saveVhclMdlInfo: (data: any) => {
        return api.post(`${BASE.api}/mdl`, {
            ...data,
        });
    },

    deleteVhclMdlInfo: (vhclMkerCd: any, vhclMdlCds: any) => {
        return api.delete(`${BASE.api}/mdl/${vhclMkerCd}/${vhclMdlCds}`);
    },

    getVhclMdlNoInfo: (vhclMkerCd: any, vhclMdlCd: any, vhclMdlNoCd: any) => {
        return api.get(`${BASE.api}/mdlNo/${vhclMkerCd}/${vhclMdlCd}/${vhclMdlNoCd}`);
    },

    saveVhclMdlNoInfo: (data: any) => {
        return api.post(`${BASE.api}/mdlNo`, {
            ...data,
        });
    },

    deleteVhclMdlNoInfo: (vhclMkerCd: any, vhclMdlCd: any, vhclMdlNoCds: any) => {
        return api.delete(`${BASE.api}/mdlNo/${vhclMkerCd}/${vhclMdlCd}/${vhclMdlNoCds}`);
    },

    // duplicate check !== 중복 체크 ==!
    getVhclMkerCheck: (vhclMkerCd: any) => {
        return api.get(`${BASE.api}/getVhclMkerCheck/${vhclMkerCd}`);
    },
};
const optionYn = [
    { label: "Y", value: "Y" },
    { label: "N", value: "N" },
];

// Vehicle Maker Management Search Form Schema !== 차량 제조사 관리 검색 폼 스키마 ==!
export const SF_VHCL_MKER_MGMT_SRCH: TFormSchema = {
    id: "form_OsciVhelMkerMgmtSrch",
    schema: {
        vhclMkerCd: { type: "text", label: "L_VHCL_MNFC_CD", maxLength: 5 },
        vhclMkerNm: { type: "text", label: "L_VHCL_MNFC_NM" },
    },
};

// Schema of Vehicle Makert Form !== 차량 제조사 상세 조회 폼 스키마 ==!
export const SF_VHCL_MKER_MGMT_INFO: TFormSchema = {
    id: "form_OsciVhelMkerMgmtInfo",
    schema: {
        vhclMkerCd: { type: "text", label: "L_VHCL_MNFC_CD", maxLength: 5, required: true },
        vhclMkerNm: { type: "text", label: "L_VHCL_MNFC_NM" },
        loclYn: {
            type: "select",
            label: "L_LOCL_YN",
            options: optionYn,
            required: true,
        },
        useYn: {
            type: "select",
            label: "L_USE_YN",
            options: optionYn,
            required: true,
        },
    },
};

// Schema of Vehicle Model Form !== 차량 모델 상세 폼 스키마 ==!
export const SF_VHCL_MDL_INFO: TFormSchema = {
    id: "form_OsciVhelMdlInfo",
    schema: {
        vhclMkerCd: { type: "text", label: "L_VHCL_MNFC_CD", maxLength: 5 },
        vhclMdlCd: { type: "text", label: "L_VHCL_MDL_CD", required: true, maxLength: 6 },
        vhclMdlNm: { type: "text", label: "L_VHCL_MDL_NM" },
        useYn: {
            type: "select",
            label: "L_USE_YN",
            options: optionYn,
            required: true,
        },
        mode: { type: "text", defaultValue: "NEW" },
    },
};

// Schema of Vehicle Model No Form !== 차량 모델 No 상세 폼 스키마 ==!
export const SF_VHCL_MDL_NO_INFO: TFormSchema = {
    id: "form_OsciVhelMdlNoInfo",
    schema: {
        vhclMkerCd: { type: "text", label: "L_VHCL_MNFC_CD", maxLength: 5 },
        vhclMdlCd: { type: "text", label: "L_VHCL_MDL_CD", maxLength: 6 },
        vhclMdlNoCd: { type: "text", label: "L_VHCL_MDL_NO_CD", required: true, maxLength: 6 },
        vhclMdlNoNm: { type: "text", label: "L_VHCL_MDL_NO_NM" },
        luxYn: {
            type: "select",
            label: "L_LUX_YN",
            options: optionYn,
            required: true,
        },
        useYn: {
            type: "select",
            label: "L_USE_YN",
            options: optionYn,
            required: true,
        },
        mode: { type: "text", defaultValue: "NEW" },
    },
};

// Vehicle Maker Management List Grid !== 차량 제조사 관리 List Grid ==!
export const SG_VHCL_MKER_MGMT_SRCH: TGridSchema = {
    id: "grid_OsciVhelMkerMgmtSrch",
    options: { pagination: "out", index: true },
    head: [
        { cells: [{ header: "L_VHCL_MNFC_CD", binding: "vhclMkerCd", width: 230 }] },
        { cells: [{ header: "L_VHCL_MNFC_NM", binding: "vhclMkerNm", width: "*" }] },
        { cells: [{ header: "L_LOCL_YN", binding: "loclYn", width: 180 }] },
        { cells: [{ header: "L_USE_YN", binding: "useYn", width: 180 }] },
        { cells: [{ header: "L_MDL_CNT", binding: "mdlCnt", width: 180 }] },
    ],
    body: [
        { cells: [{ binding: "vhclMkerCd", type: "text", align: "center" }] },
        { cells: [{ binding: "vhclMkerNm", type: "text", align: "left" }] },
        { cells: [{ binding: "loclYn", type: "text", align: "center" }] },
        { cells: [{ binding: "useYn", type: "text", align: "center" }] },
        { cells: [{ binding: "mdlCnt", type: "number", align: "right" }] },
    ],
};

// Vehicle Model List Grid !== 차량 모델 List Grid ==!
export const SG_VHCL_MDL: TGridSchema = {
    id: "grid_OsciVhelMdl",
    options: { checkbox: true },
    head: [
        { cells: [{ header: "L_VHCL_MDL_CD", binding: "vhclMdlCd", width: 230 }] },
        { cells: [{ header: "L_VHCL_MDL_NM", binding: "vhclMdlNm", width: "*" }] },
        { cells: [{ header: "L_USE_YN", binding: "useYn", width: 180 }] },
        { cells: [{ header: "L_MDL_NO_CNT", binding: "mdlNoCnt", width: 180 }] },
        { cells: [{ header: "L_MDFC", binding: "vhclMdlMdfc", width: 130 }] },
    ],
    body: [
        { cells: [{ binding: "vhclMdlCd", align: "center" }] },
        { cells: [{ binding: "vhclMdlNm", align: "left" }] },
        { cells: [{ binding: "useYn", align: "center" }] },
        { cells: [{ binding: "mdlNoCnt", type: "number", align: "right" }] },
        { cells: [{ binding: "vhclMdlMdfc", align: "center" }] },
    ],
};

// Vehicle Maker Management List Grid !== 차량 제조사 관리 List Grid ==!
export const SG_VHCL_MDL_NO: TGridSchema = {
    id: "grid_OsciVhelMdlNo",
    options: { checkbox: true },
    head: [
        { cells: [{ header: "L_VHCL_MDL_NO_CD", binding: "vhclMdlNoCd", width: 230 }] },
        { cells: [{ header: "L_VHCL_MDL_NO_NM", binding: "vhclMdlNoNm", width: "*" }] },
        { cells: [{ header: "L_LUX_YN", binding: "luxYn", width: 180 }] },
        { cells: [{ header: "L_USE_YN", binding: "useYn", width: 180 }] },
        { cells: [{ header: "L_MDFC", binding: "vhclMdlNoMdfc", width: 130 }] },
    ],
    body: [
        { cells: [{ binding: "vhclMdlNoCd", align: "center" }] },
        { cells: [{ binding: "vhclMdlNoNm", align: "left" }] },
        { cells: [{ binding: "luxYn", align: "center" }] },
        { cells: [{ binding: "useYn", align: "center" }] },
        { cells: [{ binding: "vhclMdlNoMdfc", align: "center" }] },
    ],
};
